import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {KtServicesFilterService} from '../../service/kt-services-filter.service';
import {KtServiceFilterModel} from '../../models/kt-filter.model';

@Component({
  selector: 'app-kt-services-filter-modal',
  imports: [
    MatButton,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatSuffix,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './kt-services-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
})
export class KtServicesFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<KtServicesFilterModalComponent>);
  private readonly filterService = inject(KtServicesFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;
  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const f = this.filterService.filtersValue();
    this.form.patchValue({
      TripReference: f.TripReference,
      ServiceName: f.ServiceName,
      ProductTypeName: f.ProductTypeName,
      VendorName: f.VendorName,
      ServiceStartDateFrom: f.ServiceStartDateFrom,
      ServiceStartDateTo: f.ServiceStartDateTo,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: KtServiceFilterModel = {
      TripReference: raw.TripReference,
      ServiceName: raw.ServiceName,
      ProductTypeName: raw.ProductTypeName,
      VendorName: raw.VendorName,
      ServiceStartDateFrom: raw.ServiceStartDateFrom,
      ServiceStartDateTo: raw.ServiceStartDateTo,
      ReloadGrid: true,
    };
    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      TripReference: null,
      ServiceName: null,
      ProductTypeName: null,
      VendorName: null,
      ServiceStartDateFrom: null,
      ServiceStartDateTo: null,
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
